import type { PriceData } from '@flows-ui/services/QuoteDataContext.types'
import { findPriceEntry } from '@flows-ui/utils/discounts'

/**
 * Extracts a single gross premium string from price data. A `configurationId` matches a
 * specific plan exactly; `tariffLine` is the looser fallback for products whose plans are
 * identified by that parameter alone.
 *
 * Returns '0' when no matching configuration or price is found.
 */
export const getSinglePriceWithInterval = ({
  premiumInterval,
  priceData,
  productKey,
  tariffLine,
  configurationId,
}: {
  premiumInterval: string
  priceData: PriceData | undefined
  productKey: string
  tariffLine?: string
  configurationId?: string
}): string =>
  findPriceEntry({ premiumInterval, priceData, productKey, tariffLine, configurationId })
    ?.gross_premium ?? '0'
